import { render, staticRenderFns } from "./TitleDetailQuickActionBarV1.vue?vue&type=template&id=91134f50&scoped=true"
import script from "./TitleDetailQuickActionBarV1.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDetailQuickActionBarV1.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleDetailQuickActionBarV1.vue?vue&type=style&index=0&id=91134f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91134f50",
  null
  
)

export default component.exports